"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THeadRow = exports.Row = exports.CollapsibleRowWrapper = exports.CollapsibleRow = exports.CollapsibleIconCell = exports.CollapsibleEmptyCell = exports.CollapsibleCell = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Cell = _interopRequireDefault(require("../Cell"));
var variants = _interopRequireWildcard(require("../variants"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Row = _styledComponents.default.tr.withConfig({
  displayName: "fluffy--Row",
  componentId: "fluffy--1y8fn51"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", "px;\n    line-height: ", ";\n    font-family: ", ";\n    border: ", ";\n"], ["\n    font-size: ", "px;\n    line-height: ", ";\n    font-family: ", ";\n    border: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontSizes[1];
}, function (_a) {
  var theme = _a.theme;
  return theme.lineHeights[1];
}, function (_a) {
  var theme = _a.theme;
  return theme.fonts.generic[5];
}, function (_a) {
  var theme = _a.theme;
  return "1px solid ".concat(theme.colors.grey[4]);
});
exports.Row = Row;
var THeadRow = (0, _styledComponents.default)(Row).withConfig({
  displayName: "fluffy--THeadRow",
  componentId: "fluffy--13r4bjs"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n    border: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n    border: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[0];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[5];
}, function (_a) {
  var theme = _a.theme;
  return theme.fonts.generic[4];
}, function (_a) {
  var theme = _a.theme;
  return "1px solid ".concat(theme.colors.grey[4]);
});
exports.THeadRow = THeadRow;
var CollapsibleRowWrapper = (0, _styledComponents.default)(Row).withConfig({
  displayName: "fluffy--CollapsibleRowWrapper",
  componentId: "fluffy--ubf10d"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border: none;\n"], ["\n    border: none;\n"])));
exports.CollapsibleRowWrapper = CollapsibleRowWrapper;
var CollapsibleRow = (0, _styledComponents.default)(Row).withConfig({
  displayName: "fluffy--CollapsibleRow",
  componentId: "fluffy--1u026do"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    border-bottom: ", ";\n\n    &:hover {\n        ", ";\n        cursor: pointer;\n    }\n"], ["\n    ", ";\n    border-bottom: ", ";\n\n    &:hover {\n        ", ";\n        cursor: pointer;\n    }\n"])), function (_a) {
  var $active = _a.$active;
  return variants[$active ? "tertiary" : "primary"];
}, function (_a) {
  var $active = _a.$active,
    theme = _a.theme;
  return $active ? "none" : "1px solid ".concat(theme.colors.grey[4]);
}, function (_a) {
  var $active = _a.$active;
  return !$active && variants["secondary"];
});
exports.CollapsibleRow = CollapsibleRow;
var CollapsibleEmptyCell = (0, _styledComponents.default)(_Cell.default).withConfig({
  displayName: "fluffy--CollapsibleEmptyCell",
  componentId: "fluffy--168r06x"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 1%;\n"], ["\n    width: 1%;\n"])));
exports.CollapsibleEmptyCell = CollapsibleEmptyCell;
var CollapsibleIconCell = (0, _styledComponents.default)(_Cell.default).withConfig({
  displayName: "fluffy--CollapsibleIconCell",
  componentId: "fluffy--8v9ejl"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-align: right;\n"], ["\n    text-align: right;\n"])));
exports.CollapsibleIconCell = CollapsibleIconCell;
var CollapsibleCell = (0, _styledComponents.default)(_Cell.default).withConfig({
  displayName: "fluffy--CollapsibleCell",
  componentId: "fluffy--1grygmk"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: 0px;\n"], ["\n    padding: 0px;\n"])));
exports.CollapsibleCell = CollapsibleCell;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;